import Vue from 'vue';
import VueRouter from 'vue-router';


//修复点击重复地址报错问题
const originalPush = VueRouter.prototype.push // 获取原型对象push函数
const originalReplace = VueRouter.prototype.replace // 获取原型对象replace函数
// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}

Vue.use(VueRouter)
const mainChildren = [
  {
    path: '/main/home',
    name: 'Home',
    component: () => import('../views/company/home.vue'),
    meta:{
      title: '首页'
    }
  },
  {
    path: '/main/homeEdit',
    name: 'HomeEdit',
    component: () => import('../views/company/homeEdit.vue'),
    meta:{
      title: '编辑公司资料'
    }
  },
  {
    path: '/main/operationAccount',
    name: 'OperationAccount',
    component: () => import('../views/operation/account.vue'),
    meta:{
      title: '运营账号管理'
    }
  },
  {
    path: '/main/manufacturer',
    name: 'Manufacturer',
    component: () => import('../views/operation/manufacturer.vue'),
    meta:{
      title: '厂商管理'
    }
  },
  {
    path: '/main/manufacturerAccount',
    name: 'ManufacturerAccount',
    component: () => import('../views/operation/manufacturerAccount.vue'),
    meta:{
      title: '厂商账号管理'
    }
  },
  {
    path: '/main/property',
    name: 'Property',
    component: () => import('../views/operation/property.vue'),
    meta:{
      title: '物业管理'
    }
  },
  {
    path: '/main/propertyAccount',
    name: 'PropertyAccount',
    component: () => import('../views/operation/propertyAccount.vue'),
    meta:{
      title: '物业账号管理'
    }
  },
  {
    path: '/main/stationGroup',
    name: 'StationGroup',
    component: () => import('../views/device/stationGroup.vue'),
    meta:{
      title: '桩群管理'
    }
  },
  {
    path: '/main/stationGroupCompany',
    name: 'StationGroupCompany',
    component: () => import('../views/device/stationGroupCompany.vue'),
    meta:{
      title: '桩群管理'
    }
  },
  {
    path: '/main/station',
    name: 'Station',
    component: () => import('../views/device/station.vue'),
    meta:{
      title: '充电桩管理'
    }
  },
  {
    path: '/main/stationCompany',
    name: 'StationCompany',
    component: () => import('../views/device/stationCompany.vue'),
    meta:{
      title: '充电桩管理'
    }
  },
  {
    path: '/main/pileStoreGouse',
    name: 'PileStoreGouse',
    component: () => import('../views/device/pileStoreHouse.vue'),
    meta:{
      title: '充电桩仓库'
    }
  },
  {
    path: '/main/warning',
    name: 'Warning',
    component: () => import('../views/device/warning.vue'),
    meta:{
      title: '报警管理'
    }
  },
  {
    path: '/main/warningCompany',
    name: 'WarningCompany',
    component: () => import('../views/device/warningCompany.vue'),
    meta:{
      title: '报警管理'
    }
  },
  {
    path: '/main/package',
    name: 'Package',
    component: () => import('../views/recharge/package.vue'),
    meta:{
      title: '套餐配置'
    }
  },
  {
    path: '/main/payment',
    name: 'Payment',
    component: () => import('../views/recharge/payment.vue'),
    meta:{
      title: '充值配置'
    }
  },
  {
    path: '/main/single',
    name: 'Single',
    component: () => import('../views/recharge/single.vue'),
    meta:{
      title: '单次配置'
    }
  },
  {
    path: '/main/coupon',
    name: 'Coupon',
    component: () => import('../views/recharge/coupon.vue'),
    meta:{
      title: '优惠券列表'
    }
  },


  {
    path: '/main/refund',
    name: 'Refund',
    component: () => import('../views/recharge/refund.vue'),
    meta:{
      title: '退款审核'
    }
  },
  {
    path: '/main/withdrawal',
    name: 'Withdrawal',
    component: () => import('../views/recharge/withdrawal.vue'),
    meta:{
      title: '提现审核'
    }
  },
  {
    path: '/main/stationGroupForm',
    name: 'StationGroupForm',
    component: () => import('../views/reportForm/stationGroupForm.vue'),
    meta: {
      title: '桩群数据报表'
    }
  },
  {
    path: '/main/chargeOrder',
    name: 'ChargeOrder',
    component: () => import('../views/reportForm/chargeOrder.vue'),
    meta: {
      title: '充电订单'
    }
  },
  {
    path: '/main/chargeOrderCompany',
    name: 'ChargeOrderCompany',
    component: () => import('../views/reportForm/chargeOrderCompany.vue'),
    meta: {
      title: '充电订单'
    }
  },
  {
    path: '/main/stationGroupFormCompany',
    name: 'StationGroupFormCompany',
    component: () => import('../views/reportForm/stationGroupFormCompany.vue'),
    meta: {
      title: '桩群数据报表'
    }
  },
  {
    path: '/main/userInfo',
    name: 'UserInfo',
    component: () => import('../views/userManagement/userInfo.vue'),
    meta: {
      title: '会员信息'
    }
  },
  {
    path: '/main/vip',
    name: 'Vip',
    component: () => import('../views/userManagement/VIP.vue'),
    meta: {
      title: 'VIP客户管理'
    }
  },
  {
    path: '/main/flow',
    name: 'Flow',
    component: () => import('../views/userManagement/flow.vue'),
    meta: {
      title: '用户交易记录'
    }
  },

  {
    path: '/main/feedback',
    name: 'Feedback',
    component: () => import('../views/userManagement/feedback.vue'),
    meta: {
      title: '用户反馈'
    }
  },


  {
    path: '/main/consumptionRecord',
    name: 'ConsumptionRecord',
    component: () => import('../views/userManagement/consumptionRecord.vue'),
    meta: {
      title: '消费记录'
    }
  },
  {
    path: '/main/interfaceCompany',
    name: 'InterfaceCompany',
    component: () => import('../views/interface/interfaceCompany.vue'),
    meta: {
      title: '接口管理'
    }
  },
  {
    path: '/main/interface',
    name: 'Interface',
    component: () => import('../views/interface/interface.vue'),
    meta: {
      title: '接口管理'
    }
  },

  {
    path: '/main/flowcost',
    name: 'Flowcost',
    component: () => import('../views/calc/flowcost.vue'),
    meta: {
      title: '流量费用列表'
    }
  },
  {
    path: '/main/flowcostCompany',
    name: 'FlowcostCompany',
    component: () => import('../views/calc/flowcostCompany.vue'),
    meta: {
      title: '流量费用列表'
    }
  },  
  {
    path: '/main/ledger',
    name: 'Ledger',
    component: () => import('../views/calc/ledger.vue'),
    meta: {
      title: '分账列表'
    }
  },
  {
    path: '/main/ledgerCompany',
    name: 'LedgerCompany',
    component: () => import('../views/calc/ledgerCompany.vue'),
    meta: {
      title: '收益流水'
    }
  },  

  {
    path: '/main/checkCash',
    name: 'CheckCash',
    component: () => import('../views/calc/checkCash.vue'),
    meta: {
      title: '提现列表'
    }
  },
  {
    path: '/main/checkCashCompany',
    name: 'CheckCashCompany',
    component: () => import('../views/calc/checkCashCompany.vue'),
    meta: {
      title: '提现列表'
    }
  },

  {
    path: '/main/companyBank',
    name: 'CompanyBank',
    component: () => import('../views/calc/companyBank.vue'),
    meta: {
      title: '商户账户列表'
    }
  },

  {
    path: '/main/cabCash',
    name: 'cabCash',
    component: () => import('../views/calc/cabCash.vue'),
    meta: {
      title: '备用金管理'
    }
  },



  {
    path: '/main/calc',
    name: 'Calc',
    component: () => import('../views/calc/calc.vue'),
    meta: {
      title: '未分发账单'
    }
  },
  {
    path: '/main/distributed',
    name: 'Distributed',
    component: () => import('../views/calc/distributed.vue'),
    meta: {
      title: '已分发账单'
    }
  },


  {
    path: '/main/unconfirmed',
    name: 'Unconfirmed',
    component: () => import('../views/calc/unconfirmed.vue'),
    meta: {
      title: '待确认账单'
    }
  },
  {
    path: '/main/history',
    name: 'History',
    component: () => import('../views/calc/history.vue'),
    meta: {
      title: '历史账单'
    }
  },
  {
    path: '/main/fundAccount',
    name: 'FundAccount',
    component: () => import('../views/calc/fundAccount.vue'),
    meta: {
      title: '资金账号'
    }
  },
  {
    path: '/main/calcParams',
    name: 'CalcParams',
    component: () => import('../views/calc/calcParams.vue'),
    meta: {
      title: '分账参数'
    }
  },
  {
    path: '/main/queue',
    name: 'Queue',
    component: () => import('../views/system/queue.vue'),
    meta: {
      title: '队列配置'
    }
  },
  {
    path: '/main/systemConfig',
    name: 'SystemConfig',
    component: () => import('../views/system/systemConfig.vue'),
    meta: {
      title: '系统配置'
    }
  },
  {
    path: '/main/propertyHome',
    name: 'PropertyHome',
    component: () => import('../views/propertyHome/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/main/propertyHomeEdit',
    name: 'PropertyHomeEdit',
    component: () => import('../views/propertyHome/homeEdit.vue'),
    meta:{
      title: '编辑资料'
    }
  },

  {
    path: '/main/mallCategory',
    name: 'MallCategory',
    component: () => import('../views/mall/category.vue'),
    meta:{
      title: '商品分类设置'
    }
  },
  {
    path: '/main/mallGoods',
    name: 'MallGoods',
    component: () => import('../views/mall/goods.vue'),
    meta:{
      title: '商品管理'
    }
  },
  {
    path: '/main/editGoods',
    name: 'EditGoods',
    component: () => import('../views/mall/editGoods.vue'),
    meta:{
      title: '新增商品'
    }
  },
  {
    path: '/main/mallOrder',
    name: 'MallOrder',
    component: () => import('../views/mall/orders.vue'),
    meta:{
      title: '订单管理'
    }
  },
  {
    path: '/main/mallOrderDetail',
    name: 'MallOrderDetail',
    component: () => import('../views/mall/orderDetail.vue'),
    meta:{
      title: '订单详情'
    }
  },
];
const routes = [
  {
    path: '/',
    name: 'LoginIndex',
    redirect: '/login',
    meta:{
      title: '登录'
    }
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/layout.vue'),
    children: mainChildren
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue'),
    meta:{
      title: '登录'
    }
  },
  {
    path: '/login_admin',
    name: 'LoginAdmin',
    component: () => import('../views/login_admin.vue'),
    meta:{
      title: '登录'
    }
  },
  {
    path: '/forgotPwd',
    name: 'ForgotPwd',
    component: () => import('../views/forgetPwd.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/forgotPwd_admin',
    name: 'ForgotPwdAdmin',
    component: () => import('../views/forgotPwd_admin.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/h5',
    name: 'H5',
    component: () => import('../views/chargeH5/chargeH5.vue'),
    meta: {
      title: '银联车安堡'
    }
  },
  {
    path: '/printDetail',
    name: 'PrintDetail',
    component: () => import('../views/calc/printDetail.vue'),
    meta:{
      title: '打印桩群明细'
    }
  },
  {
    path: '/calcPrint',
    name: 'CalcPrint',
    component: () => import('../views/calc/calcPrint.vue'),
    meta:{
      title: '打印厂商分帐单'
    }
  },
  {
    path: '/distributedPrint',
    name: 'DistributedPrint',
    component: () => import('../views/calc/distributedPrint.vue'),
    meta: {
      title: '打印厂商分帐单'
    }
  },
  {
    path: '/historyPrint',
    name: 'HistoryPrint',
    component: () => import('../views/calc/historyPrint.vue'),
    meta:{
      title: '打印历史分帐单'
    }
  },
  {
    path: '/unconfirmPrint',
    name: 'UnconfirmPrint',
    component: () => import('../views/calc/unconfirmPrint.vue'),
    meta:{
      title: '打印待确认账单'
    }
  },
  {
    path: '/main/deliveryTemplate',
    name: 'deliveryTemplate',
    component: () => import('../views/mall/deliveryTemplate.vue'),
    meta:{
      title: '编辑配送模板'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: "/charge_pc/",
  routes
});

router.afterEach((to, from, next) => {
  window.document.title = to.meta.title;
});

export default router
